import { trpc, TrpcInputs, TrpcOutputs } from '../../config/trpc';
import { UseResource } from '../../utils/types';

type AirportsOutput = TrpcOutputs['getAirports'][1];
type UseAirports = UseResource<AirportsOutput, never, never> & {
  count?: number;
  refetch: () => void;
};

export const useAirports = (queryParams: TrpcInputs['getAirports']): UseAirports => {
  const { isLoading, data, error, refetch } = trpc.getAirports.useQuery(queryParams, {
    refetchOnWindowFocus: false,
  });

  const itemCount = data?.[0];
  const items = data?.[1];

  return {
    data: items,
    count: itemCount,
    isLoading,
    error: error?.message,
    refetch,
  };
};
